export const NAVIGATION = {
  TICKET_SELECTION: __('Ticket selection'),
  REGISTRATION: __('Registration'),
  BILLING_DETAILS: __('Billing Information'),
  PAYMENT: __('Payment'),
};
